export default __webpack_public_path__ + "4561f42d350cc5f13acd1c2b0e03fdf3.png";